import { Modal } from 'bootstrap';
import katex from 'katex';
import "../styles/diplomation.css";

    var methodologieAnimModal = '<div id="MethodologieAnim_modal" class="modal fade" tabindex="-1" aria-hidden="true"> \
                                    <div class="modal-dialog modal-dialog-centered modal-xl"> \
                                        <div class="modal-content"> \
                                            <div class="modal-header"> \
                                                <h4 class="modal-title">Vulgarisation du taux de diplomation et qualification par cohorte (exemple d\'un centre de services scolaire)</h4> \
                                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>\
                                              </div> \
                                            <div class="modal-body"> \
                                                <h3 id="MethodologieAnim_title"" style="padding-left:40px;"></h3> \
                                                <div class="text-center"> \
                                                    <div id="MethodologieAnim_gridContainer_1" class="MethodologieAnim_gridContainer"> \
                                                        <div class="MethodologieAnim_grid"></div> \
                                                        <ul class="MethodologieAnim_legend"> \
                                                    </div> \
                                                    <div id="MethodologieAnim_gridContainer_2" class="MethodologieAnim_gridContainer"> \
                                                        <div class="MethodologieAnim_grid"></div> \
                                                        <ul class="MethodologieAnim_legend"> \
                                                    </div> \
                                                </div> \
                                                <div id="MethodologieAnim_texts" style="padding-left:30px; height:60px; margin:10px;"></div>\
                                                <div class="text-center" style="padding-top:10px;"> \
                                                    <strong><div id="MethodologieAnim_equationTitle"></div></strong> \
                                                    <div id="MethodologieAnim_equation" style="padding-top:10px;"></div> \
                                                </div> \
                                            </div> \
                                            <div class="modal-footer" style="justify-content:center;"> \
                                                <nav aria-label="Page navigation"> \
                                                    <ul class="pagination"> \
                                                        <li class="page-item"><a class="MethodologieAnim_year_btn page-link" yearId="year_1" href="#">Année 1</a></li> \
                                                        <li class="page-item"><a class="MethodologieAnim_year_btn page-link" yearId="year_2" href="#">Année 2</a></li> \
                                                        <li class="page-item"><a class="MethodologieAnim_year_btn page-link" yearId="year_3" href="#">Année 3</a></li> \
                                                        <li class="page-item"><a class="MethodologieAnim_year_btn page-link" yearId="year_4" href="#">Année 4</a></li> \
                                                        <li class="page-item"><a class="MethodologieAnim_year_btn page-link" yearId="year_5" href="#">Année 5</a></li> \
                                                        <li class="page-item"><a class="MethodologieAnim_year_btn page-link" yearId="year_6" href="#">Année 6</a></li> \
                                                        <li class="page-item"><a class="MethodologieAnim_year_btn page-link" yearId="year_7" href="#">Année 7</a></li> \
                                                    </ul> \
                                                </nav> \
                                            </div> \
                                        </div> \
                                     </div> \
                                </div>';

    export default class MethodologieAnim {
      constructor() {
        $("body").append(methodologieAnimModal);
        $(".MethodologieAnim_year_btn").click(this._triggerAnimation.bind(this));
        $("#MethodologieAnim_btn").click(function() {
            new Modal('#MethodologieAnim_modal').show();
        });
        this._cumulatePastEvents();
        this._initGrids(C.APP_TOOLS.METHODOLOGIE_ANIM.YEARS[0]);
        this._timeouts = [];
      }

    _cumulatePastEvents() {
        _.forEach(C.APP_TOOLS.METHODOLOGIE_ANIM.YEARS, function(yearConfig, idx) {
            yearConfig.PAST_EVENTS = [];
            if (idx > 0) {
                yearConfig.PAST_EVENTS = _.concat(yearConfig.PAST_EVENTS, C.APP_TOOLS.METHODOLOGIE_ANIM.YEARS[idx-1].PAST_EVENTS);
                _.forEach(C.APP_TOOLS.METHODOLOGIE_ANIM.YEARS[idx-1].EVENTS, function(eventConfig, idx2) {
                    yearConfig.PAST_EVENTS.push(eventConfig);
                });
                yearConfig.PAST_EVENTS = _.filter(_.sortBy(yearConfig.PAST_EVENTS, "CLASS"), "COUNT");
            }
        });
    };

    _triggerAnimation(el) {
        //console.log("_triggerAnimation")
        clearTimeout(this._timeout);
        var yearConfig = _.find(C.APP_TOOLS.METHODOLOGIE_ANIM.YEARS, {ID: $(el.target).attr("yearId")});
        this._initGrids(yearConfig);
        var idx = 0;
        function animateEvent() {
            var eventConfig = yearConfig.EVENTS[idx];
            var $text = $('<h5 style="opacity:0; color:' + eventConfig.COLOR + ';">' + eventConfig.TEXT +'</h5>');
            $("#MethodologieAnim_texts").append($text);
            $text.animate({opacity: 1}, 1000);
            var randomCells = _.shuffle($("#MethodologieAnim_gridContainer_1 .MethodologieAnim_cell:not(.MethodologieAnim_unoccupied)").toArray()).slice(0, eventConfig.COUNT);
            _.forEach(randomCells, function(originCell) {
                var $originCell = $(originCell);
                var $dstCell = $("#MethodologieAnim_gridContainer_2 .MethodologieAnim_cell.MethodologieAnim_unoccupied:eq(0)");
                $dstCell.removeClass("MethodologieAnim_unoccupied").addClass(eventConfig.CLASS);
                console.log($dstCell.offset(), $originCell.offset());
                $originCell.addClass("MethodologieAnim_unoccupied").animate({
                    left: Math.round($dstCell.offset().left -  $originCell.offset().left),
                    top: Math.round($dstCell.offset().top - $originCell.offset().top)},
                    2000, "linear").css({"color": eventConfig.COLOR, "z-index": "1"});
            });
            this._buildLegend();
            this._timeout = setTimeout(function() {
                idx += 1;
                if (idx < yearConfig.EVENTS.length) {
                    animateEvent.call(this);
                } else {
                    var $text = $('<h5 style="opacity:0; color:#009900;">' + yearConfig.END_TEXT +'</h5>');
                    $("#MethodologieAnim_texts").append($text);
                    $text.animate({opacity: 1}, 1000);
                    setTimeout(function() {
                        this._reogarnizeGrids(yearConfig);
                        if (typeof yearConfig.EQUATION != "undefined") {
                            $("#MethodologieAnim_equationTitle").html(yearConfig.EQUATION_TITLE);
                            katex.render(yearConfig.EQUATION, $("#MethodologieAnim_equation")[0]);
                        }
                    }.bind(this), 1000);
                }
            }.bind(this), eventConfig.COUNT > 0 ? 950 : 950);
        };
        animateEvent.call(this);
    };

    _initGrids(config) {
        console.log("_initGrids")
        $("#MethodologieAnim_title").html("<small>" + config.TITLE + "</small>");
        $("#MethodologieAnim_texts").empty();
        $("#MethodologieAnim_equationTitle").empty();
        $("#MethodologieAnim_equation").empty();
        _.forEach(config.TEXTS, function(textConfig) {
            $("#MethodologieAnim_texts").append('<h5 id="' + textConfig.ID + '" style="opacity:0;">' + textConfig.TEXT + '</h5>');
        })
        this._buildGrid("grid_1", config.START_COUNT);
        this._buildGrid("grid_2");
        this._buildLegend();
        _.forEach(config.PAST_EVENTS, function(eventConfig) {
            $("#MethodologieAnim_gridContainer_2 .MethodologieAnim_cell.MethodologieAnim_unoccupied").slice(0, eventConfig.COUNT).removeClass("MethodologieAnim_unoccupied").addClass(eventConfig.CLASS).css({"color": eventConfig.COLOR, "opacity": 1});
        });
    };

    _reogarnizeGrids(yearConfig) {
        this._reogarnizeGrid1(yearConfig);
        this._reogarnizeGrid2(yearConfig);
    }

    _reogarnizeGrid1(yearConfig) {
        var cellCount = yearConfig.START_COUNT - _.sumBy(yearConfig.EVENTS, "COUNT");
        this._buildGrid("grid_1", cellCount);
    };

    _reogarnizeGrid2(yearConfig) {
        this._buildGrid("grid_2");
        var yearEvents = _.map(yearConfig.EVENTS, function(eventConfig, idx) {
            eventConfig.ORDER = idx;
            return eventConfig;
        });
        var sortedEvents = _.filter(_.sortBy(_.concat(yearEvents, yearConfig.PAST_EVENTS), "CLASS"), "COUNT");
        _.forEach(sortedEvents, function(event) {
            $("#MethodologieAnim_gridContainer_2 .MethodologieAnim_cell.MethodologieAnim_unoccupied").slice(0, event.COUNT).removeClass("MethodologieAnim_unoccupied").css({"color": event.COLOR, "opacity": 1});
        });
    };

    _buildGrid(gridId, cellCount) {
        var rows = [];
        for (var i=0; i<10; i++) {
            var $row = $('<div class="row"></div>');
            for (var j=0; j<10; j++) {
                if ((10*i + j) < cellCount) {
                    $row.append('<div class="col-md-1 ' + (j==0 ? "offset-md-1" : "") + ' MethodologieAnim_cell"><span></span></div>');
                } else {
                    $row.append('<div class="col-md-1 ' + (j==0 ? "offset-md-1" : "") + ' MethodologieAnim_cell MethodologieAnim_unoccupied" style="opacity:0;"><span></span></div>');
                }
            }
            rows.push($row);
        }
        switch (gridId) {
            case "grid_1":
                $("#MethodologieAnim_gridContainer_1 .MethodologieAnim_grid").empty();
                $("#MethodologieAnim_gridContainer_1 .MethodologieAnim_grid").append(rows);
                $("#MethodologieAnim_gridContainer_1 .MethodologieAnim_cell").slice(cellCount).addClass("MethodologieAnim_unoccupied").css("opacity", 0);
                break;
            case "grid_2":
                $("#MethodologieAnim_gridContainer_2 .MethodologieAnim_grid").empty();
                $("#MethodologieAnim_gridContainer_2 .MethodologieAnim_grid").append(rows);
                $("#MethodologieAnim_gridContainer_2 .MethodologieAnim_cell").addClass("MethodologieAnim_unoccupied").css("opacity", 0);
                break;
            default:
                throw "MethodologieAnim._buildGrid() - gridId: " + gridId + " is invalid.";
        }
    };

    _buildLegend(yearConfig, eventConfig) {
        $("#MethodologieAnim_gridContainer_1 .MethodologieAnim_legend").empty();
        _.forEach(C.APP_TOOLS.METHODOLOGIE_ANIM.LEGENDS.GRID_1, function(legendConfig) {
            var count = $(legendConfig.SELECTOR).length;
            $("#MethodologieAnim_gridContainer_1 .MethodologieAnim_legend").append('<li><span class="MethodologieAnim_legendSquare" style="background-color:' + legendConfig.COLOR + ';"></span><span class="MethodologieAnim_legendCount">&nbsp;' + count + '&nbsp;élève' + (count > 0 ? "s" : "") + '</span></li>');
        });
        $("#MethodologieAnim_gridContainer_2 .MethodologieAnim_legend").empty();
        _.forEach(C.APP_TOOLS.METHODOLOGIE_ANIM.LEGENDS.GRID_2, function(legendConfig) {
            var count = $(legendConfig.SELECTOR).length;
            $("#MethodologieAnim_gridContainer_2 .MethodologieAnim_legend").append('<li><span class="MethodologieAnim_legendSquare" style="background-color:' + legendConfig.COLOR + ';"></span><span class="MethodologieAnim_legendCount">&nbsp;' + count + '&nbsp;élève' + (count > 0 ? "s" : "") + '</span></li>');
        });
    };

}
